import React from 'react'
import PropTypes from 'prop-types'
import { createComponent } from 'react-fela'
import { __wrapper } from './__style'

export const Wrapper = createComponent(__wrapper)

const DesktopWrapper = ({ customStyles = {}, isDesktop, children }) =>
	isDesktop ? (
		<Wrapper customStyles={customStyles}>{children}</Wrapper>
	) : (
		<>{children}</>
	)

DesktopWrapper.propTypes = {
	/**
	 * is the component open in desktop
	 */
	isDesktop: PropTypes.bool,
	/**
	 * add custom styles for the component in case user wants to override widh and other style
	 */
	customStyles: PropTypes.object,
}

DesktopWrapper.defaultProps = {
	isDesktop: false,
}

export default DesktopWrapper
